import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const geomagneticParametersMap = new Map();

geomagneticParametersMap.set(KnowEdmTableData.ModelName, {
  key: KnowEdmTableData.ModelName,
  unit: '',
  label: 'Model Name',
  quantity: '',
  tooltip: 'entities_modelNameTooltip',
});

geomagneticParametersMap.set(KnowEdmTableData.ReferenceDate, {
  key: KnowEdmTableData.ReferenceDate,
  unit: '',
  label: 'Reference Date',
  quantity: '',
  tooltip: 'entities_refereneDateTooltip',
});

geomagneticParametersMap.set(KnowEdmTableData.DipAngle, {
  key: KnowEdmTableData.DipAngle,
  label: 'Dip Angle',
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  tooltip: 'entities_dipAngleTooltip',
});

geomagneticParametersMap.set(KnowEdmTableData.Declination, {
  key: KnowEdmTableData.Declination,
  label: 'Declination',
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  tooltip: 'entities_declinationTooltip',
});

geomagneticParametersMap.set(KnowEdmTableData.MagneticField, {
  key: KnowEdmTableData.MagneticField,
  unit: defaultUnits.get(QuantitiesTypes.SensorMagnetometer),
  label: 'Magnetic Field',
  quantity: QuantitiesTypes.SensorMagnetometer,
  tooltip: 'entities_magneticFieldTooltip',
});

geomagneticParametersMap.set(KnowEdmTableData.EarthsRotationalRate, {
  key: KnowEdmTableData.EarthsRotationalRate,
  unit: defaultUnits.get(QuantitiesTypes.AngularVelocity),
  label: 'Earths Rotational Rate',
  quantity: QuantitiesTypes.AngularVelocity,
  tooltip: 'entities_earthRotationRateTooltip',
});

geomagneticParametersMap.set(KnowEdmTableData.GravityFieldModel, {
  key: KnowEdmTableData.GravityFieldModel,
  unit: '',
  label: 'Gravity field model name',
  quantity: '',
  tooltip: 'entities_gravityFieldModelTooltip',
});

geomagneticParametersMap.set(KnowEdmTableData.GravityField, {
  key: KnowEdmTableData.GravityField,
  label: 'Gravity Field',
  unit: defaultUnits.get(QuantitiesTypes.Acceleration),
  quantity: QuantitiesTypes.Acceleration,
  tooltip: 'entities_gravityFieldTooltip',
});

export {
  geomagneticParametersMap,
};
